import React from "react";
import { Box, Select, Text } from "@chakra-ui/react";
import { walletTextFieldSx } from "../artistWallet/dialogStyles";
import {
    TIER_OPTIONS,
    TIER_LABELS,
    CURRENCY_OPTIONS,
    DURATION_MONTHS_OPTIONS,
} from "./subscriptionsConstants";

const fieldLabelProps = { color: "rgba(255, 255, 255, 0.7)", fontSize: "0.8rem", mb: 1 };

const darkOptionSx = {
    "& option": { background: "rgba(30, 30, 30, 0.98)", color: "rgba(255, 255, 255, 0.9)" },
};

/**
 * Tier select dropdown shared by both create forms.
 * @param {Object} props
 * @param {string} props.value - Selected tier
 * @param {Function} props.onChange - Change handler (receives the new tier value)
 * @returns {React.ReactElement}
 */
function TierSelect({ value, onChange }) {
    return (
        <Box>
            <Text {...fieldLabelProps}>Type</Text>
            <Select value={value} onChange={(e) => onChange(e.target.value)} sx={darkOptionSx} {...walletTextFieldSx}>
                {TIER_OPTIONS.map((tier) => (
                    <option key={tier} value={tier}>{TIER_LABELS[tier] || tier}</option>
                ))}
            </Select>
        </Box>
    );
}

/**
 * Currency select dropdown shared by both create forms.
 * @param {Object} props
 * @param {string} props.value - Selected currency code
 * @param {Function} props.onChange - Change handler (receives the new currency)
 * @returns {React.ReactElement}
 */
function CurrencySelect({ value, onChange }) {
    return (
        <Box>
            <Text {...fieldLabelProps}>Devise</Text>
            <Select value={value} onChange={(e) => onChange(e.target.value)} sx={darkOptionSx} {...walletTextFieldSx}>
                {CURRENCY_OPTIONS.map((currency) => (
                    <option key={currency} value={currency}>{currency}</option>
                ))}
            </Select>
        </Box>
    );
}

/**
 * Duration in months select (1 to 12) for free subscriptions.
 * @param {Object} props
 * @param {number} props.value - Selected duration in months
 * @param {Function} props.onChange - Change handler (receives the new duration)
 * @returns {React.ReactElement}
 */
function DurationSelect({ value, onChange }) {
    return (
        <Box>
            <Text {...fieldLabelProps}>Durée (mois)</Text>
            <Select value={value} onChange={(e) => onChange(Number(e.target.value))} sx={darkOptionSx} {...walletTextFieldSx}>
                {DURATION_MONTHS_OPTIONS.map((m) => (
                    <option key={m} value={m}>{m} mois</option>
                ))}
            </Select>
        </Box>
    );
}

export { TierSelect, CurrencySelect, DurationSelect };
